import Scrollbar from "smooth-scrollbar";
import getFocusableElements from "helpers/get-focusable-elements";
import focusTrap from "helpers/focus-trap";
document.addEventListener("DOMContentLoaded", () => {
  const modals = document.querySelectorAll(".js-modal");
  [...modals].forEach((modal) => {
    document.body.appendChild(modal);
    if (!modal)
      return;
    const focusableElements = getFocusableElements(modal, "all", false);
    focusTrap(modal, focusableElements);
  });
  const scrollBars = document.querySelectorAll(".js-custom-scrollbar");
  [...scrollBars].forEach((scrollBarItem) => {
    Scrollbar.init(scrollBarItem, {
      alwaysShowTracks: true
    });
  });
});
